import React from "react";
import Icon from "@mdi/react";
import {
	mdiInfinity,
	mdiAccountBox,
	mdiInvoiceListOutline,
	mdiAccountWrench,
	mdiMessageText,
	mdiToolbox,
	mdiFileTree,
	mdiListStatus,
	mdiMessageTextOutline,
	mdiToolboxOutline,
	mdiListBoxOutline,
	mdiListBox,
	mdiStethoscope,
	mdiDoctor,
	mdiAccountHeart,
	mdiChartLine,
	mdiHospitalBuilding,
	mdiVideo,
} from "@mdi/js";
import { Tooltip } from "@mui/material";
import styles from "./styles.module.scss";
import { useAccount } from "shared/hooks";
import { navigate } from "shared/utils";
import { clsx } from "@ismael1361/utils";
import { Link } from "components";
import { AccountModel } from "shared/model";


interface NavItem {
	icon: string;
	label: string;
	href: string;
	disabled?: boolean;
	isActive?: (user?: AccountModel | null) => boolean;
	isHidden?: (user?: AccountModel | null) => boolean;
}

const createNavItem = (
	icon: string | ((isActive: boolean) => string),
	label: string,
	href: string,
	options?: Omit<NavItem, "icon" | "label" | "href">,
): NavItem => {
	return {
		get icon() {
			if (typeof icon === "function") {
				return icon(this.isActive?.() || false);
			}
			return icon;
		},
		label,
		href,
		...options,
	};
};

const topNavItems: NavItem[] = [
	// createNavItem(
	// 	(isActive) => {
	// 		return isActive ? mdiMessageText : mdiMessageTextOutline;
	// 	},
	// 	"Dashboard",
	// 	"/",
	// 	{
	// 		isActive() {
	// 			return window.location.pathname === "/";
	// 		},
	// 	},
	// ),
	// {
	// 	icon: mdiAccountGroup,
	// 	label: "Minhas Equipes",
	// 	href: "/workspaces",
	// 	isActive: () => /^\/workspaces/i.test(window.location.pathname),
	// },
	// {
	// 	icon: mdiAccountBox,
	// 	label: "Meus Membros",
	// 	href: "/my-teams",
	// 	isActive: () => window.location.pathname === "/my-teams",
	// },
	// {
	// 	icon: mdiTextBoxMultipleOutline,
	// 	label: "Biblioteca",
	// 	href: "/library",
	// 	isActive: () => window.location.pathname === "/library",
	// },
	// createNavItem(
	// 	(isActive) => {
	// 		return isActive ? mdiToolbox : mdiToolboxOutline;
	// 	},
	// 	"Ferramentas",
	// 	"/tools",
	// 	{
	// 		isActive: () => /^\/tools/i.test(window.location.pathname),
	// 	},
	// ),
	// createNavItem(
	// 	(isActive) => {
	// 		return isActive ? mdiListBox : mdiListBoxOutline;
	// 	},
	// 	"Tarefas",
	// 	"/tasks",
	// 	{
	// 		isActive: () => /^\/tasks/i.test(window.location.pathname),
	// 	},
	// ),
	// ── Medical ────────────────────────────────
	createNavItem(
		mdiDoctor,
		"Médico",
		"/medical/doctor",
		{
			isActive: () => /^\/medical\/doctor/i.test(window.location.pathname),
			isHidden: (user) => { const p = user?.settings?.medicalProfile; return p !== "doctor" && p !== "both"; },
		},
	),
	createNavItem(
		mdiAccountHeart,
		"Paciente",
		"/medical/patient",
		{
			isActive: () => /^\/medical\/patient/i.test(window.location.pathname),
			isHidden: (user) => { const p = user?.settings?.medicalProfile; return p !== "patient" && p !== "both"; },
		},
	),
	createNavItem(
		mdiChartLine,
		"Dashboard",
		"/medical/dashboard",
		{
			isActive: () => /^\/medical\/dashboard/i.test(window.location.pathname),
			isHidden: (user) => { const p = user?.settings?.medicalProfile; return p !== "doctor" && p !== "both"; },
		},
	),
	createNavItem(
		mdiVideo,
		"Teleconsulta",
		"/medical",
		{
			isActive: () => /^\/medical\/teleconsultation/i.test(window.location.pathname),
			isHidden: (user) => !user?.settings?.medicalProfile,
			onClick: () => {
				const roomId = crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36);
				window.location.href = `/medical/teleconsultation/${roomId}`;
			},
		},
	),
];

const bottomNavItems: NavItem[] = [
	createNavItem(mdiInvoiceListOutline, "Faturamento", "/", { disabled: true }),
	// createNavItem(mdiCog, "Preferências", "/settings", { isActive: () => /^\/settings/i.test(window.location.pathname) }),
	createNavItem(mdiAccountWrench, "Backoffice", "/backoffice", {
		isHidden: (user) => !user?.containsPermissionBy(2),
		isActive: () => /^\/backoffice/i.test(window.location.pathname),
	}),
];

// ── Main component ────────────────────────────────────────────────

export const IconSidebar: React.FC = () => {
	const user = useAccount();

	return (
		<aside className={styles.sidebar}>
			<div className={styles.topGroup}>
				<Link
					href="/"
					className={styles.logo}
				>
					<Icon
						path={mdiInfinity}
						size={0.8}
						style={{ color: "white", fontWeight: 800 }}
					/>
				</Link>
				<nav className={styles.nav}>
					{topNavItems.map((item, i) => {
						if (item.isHidden?.(user)) return null;
						const isActive = item.isActive?.(user);
						return (
							<Tooltip key={i} title={item.label} placement="right" arrow>
								<Link
									href={item.href}
									className={clsx(styles.navItem, isActive && styles.active)}
									disabled={item.disabled}
								>
									<Icon
										path={item.icon}
										size={1}
									/>
								</Link>
							</Tooltip>
						);
					})}
				</nav>
			</div>
			<div className={styles.bottomGroup}>
				<nav className={styles.nav}>
					{bottomNavItems.map((item, i) => {
						if (item.isHidden?.(user)) return null;
						const isActive = item.isActive?.(user);
						return (
							<Link
								key={i}
								href={item.href}
								className={clsx(styles.navItem, isActive && styles.active)}
								disabled={item.disabled}
								title={item.label}
							>
								<Icon
									path={item.icon}
									size={1}
								/>
							</Link>
						);
					})}
				</nav>
				<div
					className={styles.avatar}
					onClick={() => navigate("/settings")}
					title="Meu Perfil"
				>
					{user?.profilePictureUrl ? (
						<img
							src={user.profilePictureUrl}
							alt={user?.shortDisplayName || "Perfil"}
						/>
					) : (
						<Icon
							path={mdiAccountBox}
							size={1}
							color="white"
						/>
					)}
				</div>
			</div>
		</aside>
	);
};
